import { AxiosResponse } from "axios";
import { axiosInstance, MessageResponse } from "./common";

export enum AssetClassification {
  STANDARD = "STANDARD",
  SMA_0 = "SMA_0",
  SMA_1 = "SMA_1",
  SMA_2 = "SMA_2",
  SUB_STANDARD = "SUB_STANDARD",
  DOUBTFUL = "DOUBTFUL",
  LOSS = "LOSS",
  WRITTEN_OFF = "WRITTEN_OFF",
  OTHER = "OTHER",
}

export const ASSET_CLASSIFICATION_LABELS: Record<
  AssetClassification,
  string
> = {
  [AssetClassification.STANDARD]: "Standard",
  [AssetClassification.SMA_0]: "SMA 0",
  [AssetClassification.SMA_1]: "SMA 1",
  [AssetClassification.SMA_2]: "SMA 2",
  [AssetClassification.SUB_STANDARD]: "Sub-Standard (NPA)",
  [AssetClassification.DOUBTFUL]: "Doubtful (NPA)",
  [AssetClassification.LOSS]: "Loss (NPA)",
  [AssetClassification.WRITTEN_OFF]: "Written Off",
  [AssetClassification.OTHER]: "Other",
};


export interface CreditAccountCurrentPosition {
  account_number: string;
  as_of_date?: string | null;
  outstanding_balance?: number | null;
  principal_outstanding?: number | null;
  interest_outstanding?: number | null;
  accrued_interest?: number | null;
  total_dues?: number | null;
  overdue_amount?: number | null;
  remaining_term_months?: number | null;
  installments_overdue_months?: number | null;
  days_past_due?: number | null;
  asset_classification?: AssetClassification | null;
}

export interface GetCreditAccountCurrentPositionsResponse {
  current_positions: CreditAccountCurrentPosition[];
}

export interface UpsertCreditAccountCurrentPositionRequest {
  as_of_date: string;
  outstanding_balance?: number | null;
  principal_outstanding?: number | null;
  interest_outstanding?: number | null;
  accrued_interest?: number | null;
  total_dues?: number | null;
  overdue_amount?: number | null;
  remaining_term_months?: number | null;
  installments_overdue_months?: number | null;
  days_past_due?: number | null;
  asset_classification?: AssetClassification | null;
}

export const CreditAccountCurrentPositionsAPI = {
  getFromET: async (account_numbers: string[]) => {
    const response: AxiosResponse<GetCreditAccountCurrentPositionsResponse> =
      await axiosInstance.get(
        "/v1/et/credit-account-current-positions",
        {
          params: {
            account_numbers,
          },
        }
      );

    return response.data;
  },

  upsert: async (
    case_id: string,
    account_number: string,
    request: UpsertCreditAccountCurrentPositionRequest
  ) => {
    const response: AxiosResponse<MessageResponse> =
      await axiosInstance.put(
        `/v1/cases/${case_id}/credit-accounts/${account_number}/credit-account-current-positions`,
        request
      );

    return response.data;
  },
};